module.exports = __webpack_public_path__ + "img/enableshareicon.159e40a8.svg";